<template>
  <div class="template" id="template">
    <div class="fixedChat" @mouseenter="clickStatus" @click="clickStatus" :class="chatStatus==0?'online':''">
      <div class="item">
        <a id="">
          <div class="rings">
            <div class="ring"></div>
            <div class="ring"></div>
            <div class="ring"></div>
          </div>
        </a>
      </div>
      <div v-if="isShow" class="selectCon">
        <el-select v-model="chatStatus" :placeholder="$t('im.imIndex.chatStatus')" @change="changeStatus">
          <el-option
            v-for="item in chatStatusList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <el-dialog :title="$t('im.common.tip')" :visible.sync="isSocket" width="30%" center :before-close="reconnectSocket" :modal-append-to-body="false">
        <span>{{$t('im.imIndex.chatDisconnect')}}</span>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="refresh">{{$t('im.imIndex.refresh')}}</el-button></span>
      </el-dialog>
      <div class="popFixed" v-if="isChatPop">
        <div class="tcCon" @click="goChat">
          <span>{{$t('im.imIndex.chatTip')}}</span>
          <p>{{$t('im.imIndex.chatTipCon')}}</p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  require('@/styles/IM/template.css');
  import { localRead, localSave , localRemove} from '@/utils/tools'
  import Msg from '@/utils/IM/Msg_pb'
  import imStore from '@/store/modules/im'
  import Util from "@/utils/IM/tradeDataUtil"
  import apiChatSystem from "@/api/im/chatSystem"

  let webSocket = null
  export default {
    name: 'im',
    data() {
      return {
        userInfo: JSON.parse(localRead('sys_userInfo_IM')),
        isSocket: false,  //socket是否断开
        chatUrl: process.env.VUE_APP_CHAT_URL,   //会话socket的URL/
        // chatUrl:'ws://172.25.10.236:5003/ws',
        sessionId: '',   //会话ID
        privateSessionIDs: '',   //用户私聊会话ID
        localeList: [],  //语言列表
        chatStatusVal: true,
        chatStatus: 1,
        chatStatusList: [
          { name: window.$t('im.common.online'), id: 0 },
          { name: window.$t('im.common.business'), id: 1 }
        ],//客服状态
        isShow: false,
        isChangeStatusSuc: false,
        pingNum: null,
        userToken: Util.isEmpty(this.$route.query.id) ? JSON.parse(localRead('sys_userInfo_IM')).userToken : this.$route.query.id,//客服userToken
        isChatPop: false,  //socket是否断开
        chatType: '',//聊天类型——0：智能，1：人工，2：私聊，3：群聊
        newAdvanceData: []//预输入数据
      }
    },
    computed: {
      sessionIds: {
        get() {
          return this.$store.state.im.sessionId
        }
      },
      singleUserTokens: {
        get() {
          return this.$store.state.im.singleUserToken
        }
      },
      webSocket: {
        get() {
          return this.$store.state.im.webSockets
        }
      },
      //用户未读休息数
      messageCount: {
        get() {
          return this.$store.state.im.messageNums
        }
      },
      //客服私聊消息数量
      singleMessageCount: {
        get() {
          return this.$store.state.im.singleMessageNums
        }
      }
    },
    methods: {
      // 全局关闭表情容器
      globalClick() {
        document.onclick = e => {
          if (e.target.className != 'fixedChat') {
            this.isShow = false
          }
        }
      },
      /*初始化语言*/
      initLang() {
        let name = '', language
        if (Util.isNotEmpty(this.userInfo.language)) {
          if (this.userInfo.language.indexOf(',') > -1) {
            language = this.userInfo.language.split(',')
          } else {
            language = [this.userInfo.language]
          }
          for (let i in language) {
            if (language[i] == 'cn'||language[i] == 'zh_CN') {
              name = '简体中文'
            } else if (language[i] == 'en'||language[i] == 'en_US') {
              name = 'English'
            } else if (language[i] == 'vn'||language[i] == 'vi_VN') name = 'Tiếng Việt'
            this.localeList.push({ 'id': language[i], 'name': name })
          }
        }
        localSave('locale_IM', JSON.stringify(this.localeList))
      },
      clickStatus() {
        this.isShow = !this.isShow
      },
      /*初始化客服状态*/
      initStatus() {
        let data = {
          userToken: this.userInfo.userToken,
          companyId: this.userInfo.companyId
        }
        apiChatSystem.queryMyStatus(data).then(res => {
          if (res.code == 0) {
            this.chatStatus = res.result
            if (this.chatStatusVal) {
              this.initWebsocket(this.userInfo)
              this.pingNum = setInterval(() => {
                if (!this.isSocket && document.getElementById('template')) this.sendPingMessage('ping')
              }, 5000)
            }
            this.chatStatusVal = false
          }
        })
      },
      /*选择客服状态*/
      changeStatus(val) {
        this.sendChatStatus(val)
      },
      /*重新连接Socket*/
      reconnectSocket() {
        this.isShow = false
        this.initWebsocket(this.userInfo)
      },
      /*初始化IM聊天Socket*/
      initWebsocket(userInfo) {
        if (typeof WebSocket === undefined) {
          this.$alert(window.$t('im.imIndex.notWebSocket'), { confirmButtonText: window.$t('im.bt.definite'), });
        } else {
          webSocket = new WebSocket(this.chatUrl)
          webSocket.binaryType = 'arraybuffer'
          webSocket.onopen = () => {
            console.log(window.$t('im.imIndex.onopen'))
            //服务器登录
            let businessId = []
            for (let i in userInfo.businessIdUser) {
              businessId.push(userInfo.businessIdUser[i].code)
            }
            this.isSocket = false
            let messageData = new Msg.MessageData()
            messageData.setMessagedatatype(Msg.MessageDataType.CLIENT_LOGIN)
            let clientLogin = new Msg.LoginMessage()
            clientLogin.setCompanyid(userInfo.companyId)
            clientLogin.setUserid(userInfo.id)
            clientLogin.setBizcode(businessId.join(','))
            clientLogin.setAccount(userInfo.userName)
            clientLogin.setName(userInfo.displayName)
            clientLogin.setUsertoken(userInfo.userToken)
            clientLogin.setLocale(userInfo.language)
            clientLogin.setClienttype(Msg.ClientType.PC_CLIENT)
            clientLogin.setUsertype(Msg.UserType.SERVICE_USER)
            clientLogin.setBusinesslimit(userInfo.top)
            clientLogin.setServicestatus(this.chatStatus)
            messageData.setLoginmessage(clientLogin)
            let messageArray = messageData.serializeBinary()
            webSocket.send(messageArray)
          }
          webSocket.onclose = (e) => {
            console.log(window.$t('im.imIndex.onclose'));
            console.log(new Date()+"-----"+navigator.onLine);
            console.log(e);
            this.isSocket = true
          }
          webSocket.onmessage = (e) => {
            let val
            if (this.IEVersion() == -1) {
              val = e.data
            } else {
              val = new Uint8Array(e.data)
            }
            let messageData = Msg.MessageData.deserializeBinary(val)
            let messageType = messageData.getMessagedatatype()
            switch (messageType) {
              case 0:
                // 连接成功
                console.log(window.$t('im.imIndex.onmessage'))
                this.isSocket = false
                imStore.dispatch('setWebSocket', webSocket)
                this.sessionId = messageData.getChatmessage().getContent()
                break
              case 4:
                //用户私聊
                let privateData = {}, data = [];
                if (messageData.getChatmessage().getUsertoken() == this.userToken) {
                  data.push(this.getMsgObj(messageData.getChatmessage()))
                  privateData[this.userToken] = data
                  imStore.dispatch('setChatData', privateData)
                  if (Util.isNotEmpty(this.sessionIds[this.userToken])) {
                    this.sendReadMessage(this.userToken, messageData.getChatmessage().getSessionid())
                  }
                  this.chatType = 1
                  /*if (this.$route.path != '/chatSystem/chatSystem/:index') {
                    this.isChatPop = true
                    setTimeout(() => {
                      this.isChatPop = false
                    }, 3000)
                  }*/
                }
                if (messageData.getChatmessage().getSessiontype() == 0) {
                  data.push(this.getMsgObj(messageData.getChatmessage()))
                  privateData['intelligent'] = data
                  imStore.dispatch('setChatData', privateData)
                  this.chatType = 0
                  /*if (this.$route.path != '/chatSystem/intelligentChat') {
                    this.isChatPop = true
                    setTimeout(() => {
                      this.isChatPop = false
                    }, 3000)
                  }*/
                }
                if (Util.isNotEmpty(this.getMsgObj(messageData.getChatmessage()).customerId)){
                  this.isChatPop = true
                  this.callNotificationModule(`${messageData.getChatmessage().getFromname()}: ${messageData.getChatmessage().getContent()}`)
                  setTimeout(() => {
                    this.isChatPop = false
                  }, 3000)
                }
                break
              case 5:
                //客服私聊
                let privateChatData, newPrivateChatData = []
                privateChatData = this.getMsgObj(messageData.getChatmessage())
                newPrivateChatData.push(privateChatData)
                imStore.dispatch('setChatDataSingle', newPrivateChatData)
                if (Util.isEmpty(this.singleUserTokens)) this.sendReadSingleMessage(messageData)
                this.chatType = 2
                if (privateChatData.from!=this.userInfo.userToken){
                  this.isChatPop = true
                  this.callNotificationModule()
                  setTimeout(() => {
                    this.isChatPop = false
                  }, 3000)
                }
                break
              case 6:
                //客服群聊
                let publicChatData, newPublicChatData = []
                publicChatData = this.getMsgObj(messageData.getChatmessage())
                newPublicChatData.push(publicChatData)
                imStore.dispatch('setChatDataPublic', newPublicChatData)
                this.chatType = 3
                if (publicChatData.from!=this.userInfo.userToken){
                  this.isChatPop = true
                  this.callNotificationModule()
                  setTimeout(() => {
                    this.isChatPop = false
                  }, 3000)
                }
                break
              case 7:
                this.initStatus()
                //修改客服状态
                break
              case 8:
                //用户待接入
                this.isChatPop = true
                this.callNotificationModule()
                setTimeout(() => {
                  this.isChatPop = false
                }, 3000)
                this.initServiceMark()
                break
              case 9:
                //用户接入
                this.isChatPop = true
                this.callNotificationModule()
                setTimeout(() => {
                  this.isChatPop = false
                }, 3000)
                this.initChatList()
                break
              case 11:
                //用户上线
                this.initChatList()
                break
              case 12:
                //用户离线
                this.initChatList()
                break
              case 13:
                //用户强制离线
                this.initChatList()
                break
              case 14:
                //用户消息读取
                this.initServiceMark()
                break
              case 15:
                //客服上线
                this.initServiceStatus()
                break
              case 16:
                //客服下线
                this.initServiceStatus()
                break
              case 17:
                //客服信息更新
                this.initServiceStatus()
                break
              case 18:
                //客服回复用户
                this.initChatList()
                break
              case 19:
                //客服接入按钮
                this.initChatList()
                break
              case 20:
                //客服接入全部按钮
                this.initChatList()
                break
              case 21:
                //客服列表评估按钮
                this.initServiceMark()
                break
              case 22:
                //客服传送会话按钮
                this.initChatList()
                break
              case 23:
                //客服传送会话通知
                this.initServiceMark()
                break
              case 24:
                //客服接受会话按钮
                this.initChatList()
                break
              case 25:
                //客服接受会话通知
                this.initChatList()
                let acceptSessionId = {};
                if (messageData.getChatmessage().getUsertoken() == this.userToken) {
                  acceptSessionId[this.userToken] = messageData.getChatmessage().getSessionid()
                  imStore.dispatch('setAcceptSessionId', acceptSessionId)
                }
                break
              case 26:
                //客服拒绝会话按钮
                this.initServiceMark()
                break
              case 27:
                //客服拒绝会话通知
                this.initChatList()
                break
              case 28:
                //客服更新用户按钮
                this.initChatList()
                break
              case 29:
                //客服结束会话按钮
                this.initChatList()
                break
              case 30:
                //客服结束会话通知
                this.initServiceMark()
                break
              case 31:
                //客服信息修复
                this.logout()
                break
              case 32:
                //客服私聊消息读取
                break
              case 34:
                //自动结束会话按钮
                this.initChatList()
                break
              /*case 35:
                //客服监控会话切换通知
                let monitorSessionId = {};
                if (messageData.getChatmessage().getUsertoken() == this.userToken){
                  monitorSessionId[this.userToken] = messageData.getChatmessage().getSessionid()
                  imStore.dispatch('setMonitorSessionId', monitorSessionId)
                }
                break*/
              case 37:
                //智能客服接入待分配按钮
                this.initChatList()
                break
              case 38:
                //智能客服接入待分配通知
                this.initIntelligentChatList()
                break
              case 39:
                //用户待接入上线
                this.initIntelligentChatList()
                break
              case 40:
                //用户待接入离线
                this.initIntelligentChatList()
                break
              case 44:
                //用户预输入
                this.isChatPop = false
                let advanceData = {};
                if (messageData.getChatmessage().getUsertoken() == this.userToken) {
                  this.newAdvanceData.push(this.getMsgObj(messageData.getChatmessage()))
                  advanceData[this.userToken] = this.newAdvanceData
                  imStore.dispatch('setAdvanceChatData', advanceData)
                }
                break
            }
          }
        }
      },
      /*刷新页面*/
      refresh() {
        this.$router.go(0)
      },
      IEVersion() {
        var userAgent = navigator.userAgent //取得浏览器的userAgent字符串
        var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 //判断是否IE<11浏览器
        var isEdge = userAgent.indexOf('Edge') > -1 && !isIE //判断是否IE的Edge浏览器
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
        if (isIE) {
          var reIE = new RegExp('MSIE (\\d+\\.\\d+);')
          reIE.test(userAgent)
          var fIEVersion = parseFloat(RegExp['$1'])
          if (fIEVersion == 7) {
            return 7
          } else if (fIEVersion == 8) {
            return 8
          } else if (fIEVersion == 9) {
            return 9
          } else if (fIEVersion == 10) {
            return 10
          } else {
            return 6//IE版本<=7
          }
        } else if (isEdge) {
          return 'edge'//edge
        } else if (isIE11) {
          return 11 //IE11
        } else {
          return -1//不是ie浏览器
        }
      },
      /*初始化客户端发出的ping*/
      sendPingMessage(message) {
        let messageData = new Msg.MessageData()
        messageData.setMessagedatatype(Msg.MessageDataType.CLIENT_PING)
        let chatMessage = new Msg.ChatMessage()
        chatMessage.setContent(message)
        messageData.setChatmessage(chatMessage)
        let messageArray = messageData.serializeBinary()
        webSocket.send(messageArray)
      },
      /*智能客服数据刷选*/
      intelligentData(data) {
        let arr = [];
        for (const i in data) {
          arr.push({
            id: data[i].getId(),
            title: data[i].getTitle(),
            content: data[i].getContent()
          })
        }
        return arr
      },
      /*IM自定义Socket信息*/
      getMsgObj(data) {
        let msgObj = {
          from: data.getFrom(),
          fromName: data.getFromname(),
          customerId: data.getFromcustomerid(),
          to: data.getTo(),
          content: data.getContent(),
          receiveTime: data.getReceivetime(),
          msgSeq: data.getMsgseq(),
          userToken: data.getUsertoken(),
          sessionId: data.getSessionid(),
          messageType:data.getMessagetype(),
          sessionType:data.getSessiontype(),
          knowledgeList:this.intelligentData(data.getKnowledgeList()),
          previousQuestion:data.getPreviousquestion(),
        }
        return msgObj
      },
      /*读取消息数*/
      sendReadMessage(userTokens,sessionId) {
        let messageData = new Msg.MessageData()
        messageData.setMessagedatatype(Msg.MessageDataType.USER_MESSAGE_READ)
        let chatMessage = new Msg.ChatMessage()
        chatMessage.setSessionid(this.sessionIds[userTokens])
        messageData.setChatmessage(chatMessage)
        let messageArray = messageData.serializeBinary()
        webSocket.send(messageArray)
        if (this.sessionIds[userTokens] != sessionId) {
          this.messageCount[sessionId]++
          imStore.dispatch('setMessageNums', JSON.parse(JSON.stringify(this.messageCount)))
        }
      },
      /*客服私聊读取消息数*/
      sendReadSingleMessage(data) {
        let messageData = new Msg.MessageData()
        messageData.setMessagedatatype(Msg.MessageDataType.SERVICE_SINGLE_MESSAGE_READ)
        let chatMessage = new Msg.ChatMessage()
        chatMessage.setFrom(this.userInfo.userToken)
        chatMessage.setTo(this.singleUserTokens)
        messageData.setChatmessage(chatMessage)
        let messageArray = messageData.serializeBinary()
        webSocket.send(messageArray)
        if (this.singleUserTokens != data.getChatmessage().getFrom()) {
          if (Util.isEmpty(this.singleMessageCount[data.getChatmessage().getFrom()])) {
            this.singleMessageCount[data.getChatmessage().getFrom()] = 1
          } else {
            this.singleMessageCount[data.getChatmessage().getFrom()]++
          }
          imStore.dispatch('setSingleMessageNums', JSON.parse(JSON.stringify(this.singleMessageCount)))
        }
      },
      /*客服状态*/
      sendChatStatus(val) {
        let messageData = new Msg.MessageData()
        messageData.setMessagedatatype(Msg.MessageDataType.SERVICE_STATUS_UPDATE)
        let clientLogin = new Msg.LoginMessage()
        clientLogin.setCompanyid(this.userInfo.companyId)
        clientLogin.setUsertoken(this.userInfo.userToken)
        clientLogin.setServicestatus(val)
        messageData.setLoginmessage(clientLogin)
        let messageArray = messageData.serializeBinary()
        webSocket.send(messageArray)
      },
      /*筛选*/
      brushData(obj) {
        let businessGroupData = this.userInfo.businessIdUser, langList = JSON.parse(localRead('locale_IM'))
        for (const j in businessGroupData) {
          if (businessGroupData[j].code == obj.bizCode) {
            obj.bizCodeName = businessGroupData[j].name
          }
        }
        for (const j in langList) {
          if (langList[j].id == obj.locale) {
            obj.localeName = langList[j].name
          }
        }
        if (obj.clientType == 0) {
          obj.clientName = window.$t('im.common.mobile')
        } else if (obj.clientType == 1) {
          obj.clientName = window.$t('im.common.pc')
        } else if (obj.clientType == 2) {
          obj.clientName = window.$t('im.common.app')
        }
        return obj
      },
      /*人工客服会话列表*/
      initChatList() {
        let data = {
          userToken: this.userToken
        }
        apiChatSystem.queryAcceptList(data).then(res => {
          if (res.code == 0) {
            let newData = []
            if (res.result) {
              newData = JSON.parse(JSON.stringify(res.result))
              for (const i in newData) {
                this.brushData(newData[i])
                if (newData[i].sessionStatus == 0) {
                  newData[i].sessionStatusName = window.$t('im.common.offline')
                } else if (newData[i].sessionStatus == 1) newData[i].sessionStatusName = window.$t('im.common.online')
                if (newData[i].userType == 0) {
                  newData[i].account = ''
                }
              }
            }
            imStore.dispatch('setChatList', newData)
            this.initMessageCount()
            this.initServiceMark()
          }
        })
      },
      /*智能客服会话列表*/
      initIntelligentChatList(){
        let data={
          companyId:this.userInfo.companyId,
          userToken: this.userInfo.userToken
        };
        apiChatSystem.queryWaitAssignList(data).then(res=>{
          if (res.code == 0){
            let newData = []
            if (res.result) {
              newData = JSON.parse(JSON.stringify(res.result))
              for (const i in newData) {
                this.brushData(newData[i])
                if (newData[i].sessionStatus == 0) {
                  newData[i].sessionStatusName = window.$t('im.common.offline')
                } else if (newData[i].sessionStatus == 1) newData[i].sessionStatusName = window.$t('im.common.online')
                if (newData[i].userType == 0) {
                  newData[i].account = ''
                }
              }
            }
            imStore.dispatch('setIntelligentChatList', newData)
          }
        })
      },
      /*初始化客服消息数量*/
      initMessageCount() {
        let data = {
          userToken: this.userToken
        }
        apiChatSystem.queryUserMessageCount(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              imStore.dispatch('setMessageNums', res.result)
            }
          }
        })
      },
      /*初始化客服私聊消息数量*/
      initSingleMessageCount() {
        let data = {
          userToken: this.userInfo.userToken
        }
        apiChatSystem.queryServiceSingleMessageCount(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              imStore.dispatch('setSingleMessageNums', res.result)
            }
          }
        })
      },
      /*初始化客服红点标记*/
      initServiceMark() {
        let data = {
          userToken: this.userToken
        }
        apiChatSystem.queryServiceMark(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              imStore.dispatch('setServiceMark', res.result)
            }
          }
        })
      },
      /*初始化客服状态*/
      initServiceStatus() {
        let data = {
          companyId: this.userInfo.companyId
        }
        apiChatSystem.queryServiceStatus(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              imStore.dispatch('setServiceStatus', res.result)
            }
          }
        })
      },
      /*退出登录*/
      async logout() {
        await this.$store.dispatch('user/logout')
        this.$router.push(`/login`)
      },
      /*去人工客服*/
      goChat(){
        this.isChatPop = false
        if (this.chatType == 0) {
          this.$router.push({
            path: '/chatSystem/intelligentChat',
            query: { label: 'IM' }
          })
        }if (this.chatType == 1) {
          this.$router.push({
            path: '/chatSystem/chatSystem/:index',
            query: { label: 'IM' }
          })
        }if (this.chatType == 2||this.chatType == 3) {
          this.$router.push({
            path: '/chatAllSystem/chatAllSystem',
            query: { label: 'IM' }
          })
        }
      },
      callNotificationModule(body) {
        if (!window.Notification) return
        if (document.hasFocus()) return

        const notification = new window.Notification(
          this.$t('im.imIndex.chatTip'),
          {
            body: body || this.$t('im.imIndex.chatTipCon')
          }
        )
        notification.addEventListener('click', evt => {
          window.moveTo(0, 0)
          window.focus()
          this.goChat()
        })
      },
      beforeunloadHandler() {
        this._beforeUnload_time = new Date().getTime()
      },
      unloadHandler(e) {
        this._gap_time = new Date().getTime() - this._beforeUnload_time
        //判断是窗口关闭还是刷新
        if (this._gap_time <= 5) {
          //如果是登录状态，关闭窗口前，移除用户
          this.webSocket.close()
          clearInterval(this.pingNum)
          localRemove('sys_userInfo_IM')
          localRemove('locale_IM')
          localRemove('IM_tabViews')
        }
      }
    },
    destroyed() {
      this.webSocket.close()
      clearInterval(this.pingNum)
      window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
      window.removeEventListener('unload', e => this.unloadHandler(e))
    },
    mounted() {
      this.globalClick()
      this.initStatus()
      this.initLang()
      this.initChatList()
      this.initIntelligentChatList()
      this.initServiceMark()
      this.initServiceStatus()
      this.initSingleMessageCount()
      window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
      window.addEventListener('unload', e => this.unloadHandler(e))
    },
    watch: {
      $route: {
        deep: true,
        handler: function(val, oldVal) {
          if (val.query.id != oldVal.query.id && Util.isNotEmpty(val.query.id)) {
            this.userToken = this.$route.query.id
          } else {
            this.userToken = JSON.parse(localRead('sys_userInfo_IM')).userToken
          }
          if (val.name == 'IM/chatSystem/artificialChat' || val.name == 'IM/chatSystem/intelligentChat' || val.name == 'IM/chatAllSystem/chatAllSystem') {
            this.initChatList()
            this.initIntelligentChatList()
          }
        }
      }
    }
  }
</script>
